export default "__VITE_ASSET__D_7FVoid__"